import type { CustomAPI } from '../api';

/**
 * Sets an API based on an identifier.
 * @param identifier - API identifier.
 * @param api - API to be set.
 */
export function setAPI<T>(identifier: string, api: CustomAPI | T): void {
  if (!window.SYDLE) {
    window.SYDLE = {};
  }

  if (!window.SYDLE?.api) {
    window.SYDLE.api = {};
  }

  window.SYDLE.api[identifier] = api;
}
